// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
        --background: 0 0% 100%;
        --foreground: 0 0% 3.9%;
        --card: 0 0% 100%;
        --card-foreground: 0 0% 3.9%;
        --popover: 0 0% 100%;
        --popover-foreground: 0 0% 3.9%;
        --primary: 0 0% 9%;
        --primary-foreground: 0 0% 98%;
        --secondary: 0 0% 96.1%;
        --secondary-foreground: 0 0% 9%;
        --muted: 0 0% 96.1%;
        --muted-foreground: 0 0% 45.1%;
        --accent: 0 0% 96.1%;
        --accent-foreground: 0 0% 9%;
        --destructive: 0 84.2% 60.2%;
        --destructive-foreground: 0 0% 98%;
        --border: 0 0% 89.8%;
        --input: 0 0% 89.8%;
        --ring: 0 0% 3.9%;
        --chart-1: 12 76% 61%;
        --chart-2: 173 58% 39%;
        --chart-3: 197 37% 24%;
        --chart-4: 43 74% 66%;
        --chart-5: 27 87% 67%;
        --radius: 0.5rem;
        --sidebar-background: 0 0% 98%;
        --sidebar-foreground: 240 5.3% 26.1%;
        --sidebar-primary: 240 5.9% 10%;
        --sidebar-primary-foreground: 0 0% 98%;
        --sidebar-accent: 240 4.8% 95.9%;
        --sidebar-accent-foreground: 240 5.9% 10%;
        --sidebar-border: 220 13% 91%;
        --sidebar-ring: 217.2 91.2% 59.8%;
    }

.dark {
        --background: 0 0% 3.9%;
        --foreground: 0 0% 98%;
        --card: 0 0% 3.9%;
        --card-foreground: 0 0% 98%;
        --popover: 0 0% 3.9%;
        --popover-foreground: 0 0% 98%;
        --primary: 0 0% 98%;
        --primary-foreground: 0 0% 9%;
        --secondary: 0 0% 14.9%;
        --secondary-foreground: 0 0% 98%;
        --muted: 0 0% 14.9%;
        --muted-foreground: 0 0% 63.9%;
        --accent: 0 0% 14.9%;
        --accent-foreground: 0 0% 98%;
        --destructive: 0 62.8% 30.6%;
        --destructive-foreground: 0 0% 98%;
        --border: 0 0% 14.9%;
        --input: 0 0% 14.9%;
        --ring: 0 0% 83.1%;
        --chart-1: 220 70% 50%;
        --chart-2: 160 60% 45%;
        --chart-3: 30 80% 55%;
        --chart-4: 280 65% 60%;
        --chart-5: 340 75% 55%;
        --sidebar-background: 240 5.9% 10%;
        --sidebar-foreground: 240 4.8% 95.9%;
        --sidebar-primary: 224.3 76.3% 48%;
        --sidebar-primary-foreground: 0 0% 100%;
        --sidebar-accent: 240 3.7% 15.9%;
        --sidebar-accent-foreground: 240 4.8% 95.9%;
        --sidebar-border: 240 3.7% 15.9%;
        --sidebar-ring: 217.2 91.2% 59.8%;
    }

*{
  border-color: hsl(var(--border));
  outline-color: hsl(var(--ring) / 0.5);
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-right-12{
  right: -3rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-3\\.5{
  top: 0.875rem;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3\\.5{
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.h-svh{
  height: 100svh;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-8rem\\)\\]{
  min-height: calc(100vh - 8rem);
}
.min-h-screen{
  min-height: 100vh;
}
.min-h-svh{
  min-height: 100svh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-10{
  width: 2.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-4{
  width: 1rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[--sidebar-width\\]{
  width: var(--sidebar-width);
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-5{
  min-width: 1.25rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[--skeleton-width\\]{
  max-width: var(--skeleton-width);
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-px{
  --tw-translate-x: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px{
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-none{
  list-style-type: none;
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[--color-border\\]{
  border-color: var(--color-border);
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-sidebar-border{
  border-color: hsl(var(--sidebar-border));
}
.border-transparent{
  border-color: transparent;
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[--color-bg\\]{
  background-color: var(--color-bg);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sidebar{
  background-color: hsl(var(--sidebar-background));
}
.bg-sidebar-border{
  background-color: hsl(var(--sidebar-border));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-6{
  padding: 1.5rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-none{
  line-height: 1;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sidebar-foreground{
  color: hsl(var(--sidebar-foreground));
}
.text-sidebar-foreground\\/70{
  color: hsl(var(--sidebar-foreground) / 0.7);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.opacity-0{
  opacity: 0;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\]{
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-sidebar-ring{
  --tw-ring-color: hsl(var(--sidebar-ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c right\\2c width\\]{
  transition-property: left,right,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[margin\\2c opacity\\]{
  transition-property: margin,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c height\\2c padding\\]{
  transition-property: width,height,padding;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  animation-timing-function: linear;
}


/* :root {
  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;

  color-scheme: light dark;
  color: rgba(255, 255, 255, 0.87);
  background-color: #242424;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  font-weight: 500;
  color: #646cff;
  text-decoration: inherit;
}
a:hover {
  color: #535bf2;
}

body {
  margin: 0;
  display: flex;
  place-items: center;
  min-width: 320px;
  min-height: 100vh;
}

h1 {
  font-size: 3.2em;
  line-height: 1.1;
}

button {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #1a1a1a;
  cursor: pointer;
  transition: border-color 0.25s;
}
button:hover {
  border-color: #646cff;
}
button:focus,
button:focus-visible {
  outline: 4px auto -webkit-focus-ring-color;
}

@media (prefers-color-scheme: light) {
  :root {
    color: #213547;
    background-color: #ffffff;
  }
  a:hover {
    color: #747bff;
  }
  button {
    background-color: #f9f9f9;
  }
} */

.ant-modal-confirm-body-wrapper {
    width: 100%;
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
}

p {
    margin: 0;
}

/*#root {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !* height: 100vh; *!*/
/*  margin: 20px 0;*/
/*};*/

.App {
    justify-content: center;
    align-items: center;
    width: 45%;
}

.ant-modal-body {
    justify-content: center;
    align-items: center;
    display: flex;
}

.big_container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f3f6fa;
    /*background-color: var(--clr);*/
    /*align-items: center;*/
    padding: 20px;
}

.header_box {
    display: flex;
    justify-content: end
}

.main_box {
    display: flex;
    width: 85%;
}

.main_box_right {
    padding: 20px;
    width: 100%;
}

.main_box_right_header {
    display: flex;
    align-content: center;
    justify-content: center;
    /*margin-bottom: 20px;*/
}


.tabs_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 10px 30px
}

/*.top_header{*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*}*/

.table_component_container {
    padding: 20px;
}

.sidebar_box {
    width: 256px;
}

.tab_pane_text {
    font-size: 18px;
    font-weight: 500;
    padding: 25px 25px 0 25px;
}

.tab_pane_deFi_shield {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

/* .demo-loadmore-list {
    min-height: 700px;
} */

.card__product__yellow {
    color: #EFB661 !important;
}

.card__product__green {
    color: #4DC7B5 !important;
}

.card__product__red {
    color: #F27281 !important;
}

.card__product__white {
    color: white !important;
}


.card__risk__chart__min__wrapper {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.user_access_btn {
    background: #11CC7A;
    border-radius: 5px;
    padding: 0px 15px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    /*margin-right:10px;*/
    cursor: pointer;
    height: 30px;
    min-width: 80px;
}

.user_access_btn:hover,
.user_access_btn:focus {
    background: #11CC7A;
    color: #FFFFFF;
}

.user_access_text {
    color: #28B663;
    /*pointer-events: none;*/
}

.user_unaccess_text {
    color: red;
    margin-left: 10px;
}


.margin_right {
    margin-right: 15px;
}


/* From uiverse.io */
.delete_btn {
    width: 90px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 5px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
    background: #e62222;
}

.delete_btn,
.delete_btn span {
    transition: 200ms;
}

.delete_btn .text {
    transform: translateX(10px);
    color: white;
    font-weight: bold;
}

.delete_btn .icon {
    position: absolute;
    border-left: 1px solid #c41b1b;
    transform: translateX(60px);
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.deFi_shield_connections_container {
    width: 100%;
}

.delete_btn svg {
    width: 15px;
    fill: #eee;
}

.delete_btn:hover {
    background: #ff3636;
}

.delete_btn:hover .text {
    color: transparent;
}

.delete_btn:hover .icon {
    width: 90px;
    border-left: none;
    transform: translateX(0);
}

.delete_btn:focus {
    outline: none;
}

.delete_btn:active .icon svg {
    transform: scale(0.8);
}

.user_shield_box {
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex-wrap: wrap;
}

.user_shield_box_block {
    width: 200px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.user_shield_box_block_text {
    color: #1890ff;
    font-size: 20px;
}

.user_shield_box_block_cancel {
    border-radius: 5px;
    padding: 0 15px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    /*margin-right:10px;*/
    cursor: pointer;
    height: 30px;
    background: #e62222;
    min-width: 80px;
}

.user_shield_box_block_cancel:hover,
.user_shield_box_block_cancel:focus {
    background: #e62222;
    color: #FFFFFF;
}


.no_date_text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px
}


.slider_box {
    position: absolute;
    bottom: 4px;
}

.tab_title_box {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}

.slider_box>.ant-slider-rail {
    width: 8px !important;
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;
}

.slider_box>.ant-slider-track {
    position: absolute;
    height: 4px;
    background-color: #F27281 !important;
    transition: background-color 0.3s;
    width: 8px !important;
    border-radius: 88px;

}

.slider_box>.ant-slider-handle {
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    box-shadow: inset 2px 0 5px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;
    background: #F27281;
    border: 3px solid #d0d0dc;
}


.slider_box_auto_unstacking {
    position: absolute;
    bottom: 4px;
}

.tab_title_box {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}

.slider_box_auto_unstacking>.ant-slider-rail {
    width: 8px !important;
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;
}

.slider_box_auto_unstacking>.ant-slider-track {
    position: absolute;
    height: 4px;
    background-color: #385483 !important;
    transition: background-color 0.3s;
    width: 8px !important;
    border-radius: 88px;

}

.slider_box_auto_unstacking>.ant-slider-handle {
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    box-shadow: inset 2px 0 5px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;
    background: #385483;
    border: 3px solid #d0d0dc;
}


@media (max-width: 1024px) {
    .main_box {
        flex-direction: column;
    }

    .sidebar_box {
        width: 100%;
        margin-bottom: 20px;
    }

    .tabs_container {
        margin: 0;
    }

    .table_component_container {
        padding: 0;
    }
}

.error_container {
    align-items: center;
    text-align: center;
    padding: 5px;
    font-weight: 500;
    font-size: 16px;
    color: #ff4d4f;
}

.score__continer {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

}

.score__line {
    font-size: 20px;
    font-weight: 900;
    color: black;
    margin: 0 10px;
    display: flex;
    /* height: 55px; */
}

.asset__risk__calculate__modal {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.asset__risk__calculate__form__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.asset__risk__calculate__descriprion__content {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 15px;
}

.calculate__buttons {
    display: flex;
}

.platform__btn {
    margin: 0 10px;
}

.score__item {
    display: flex;
    margin: 5px 0;
}

/* 
.component__item{
    border-bottom: 1px solid #f0f0f0;    
} */
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
    /* font-size: \$fz; */
}


.ReactModal__Overlay {
    background: none !important;
    z-index: 9 !important;
}

.card__product__stake_active {
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
}


/*range */

.rangeslider-vertical {
    width: 8px !important;
    height: 133px !important;
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;
    /* position: absolute !important; */
    left: 5px !important;
    top: 0 !important;
    margin: 0 !important;
}

.rangeslider {
    margin: 2px 0 !important;
}

.rangeslider-vertical .rangeslider__handle-label {

    width: 16px !important;
    display: flex !important;
    height: 16px !important;
    border-radius: 50% !important;
    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;
}

.card__slider .rangeslider-vertical .rangeslider__handle-label {
    background: #F27281 !important;
}

.rangeslider-vertical .rangeslider__handle {
    width: 27px !important;
    height: 27px !important;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgb(54 54 77 / 40%) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    position: absolute !important;
    left: -9px !important;
    cursor: pointer !important;
}

.rangeslider-vertical .rangeslider__fill {

    box-shadow: inset 3px 3px 3px rgb(64 64 80 / 33%) !important;
    border-radius: 0px 0px 20px 20px !important;
}

.card__slider .rangeslider-vertical .rangeslider__fill {
    background: #F27281 !important;
}

.rangeslider__labels {
    display: none;
}

.rangeslider-horizontal {
    width: 105px !important;
    height: 8px !important;
    box-shadow: inset 3px 3px 3px #aeaec033, inset -3px -3px 3px #ffffffb2 !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;


}

.rangeslider-horizontal .rangeslider__fill {
    height: 100% !important;
    background: #F27281 !important;
    box-shadow: inset 3px 3px 3px #40405053 !important;
    border-radius: 20px 0 0 20px !important;
    position: absolute !important;
    left: 0 !important;
}

.rangeslider-horizontal .rangeslider__handle {
    width: 24px !important;
    height: 24px !important;
    background: #F0F0F3 !important;
    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px #36364d67 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    cursor: pointer !important;
}

.rangeslider-horizontal .rangeslider__handle-label {
    background: #F27281;
    width: 16px;
    display: flex;
    height: 16px;
    border-radius: 50%;
    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%);
}

.rangeslider__handle::after {
    display: none !important;
}

.current__card .rangeslider-horizontal {
    width: 105px;
}


/* CUSTOM CSS TO CENTER PERCENTAGE IN PROGRESSBAR */
.card__risk__chart__min__wrapper,
.card__risk__chart__min__wrapper_aside {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.card__risk__chart__min__wrapper__defi__list {
    top: 50% !important;
}

.card__risk__chart__min__wrapper_aside {
    top: 35% !important;
}

.qr__logo {
    width: 100px;
    height: 100px;
    opacity: 1;
    display: flex;
    margin: 0 auto 20px;
}

.selected__type {
    border: 1px solid red;
}


input[type="file"] {
    display: none;
    cursor: pointer;
}

.upload__content {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    box-shadow: -8px -8px 15px #ffffff, 8px 8px 15px #aeaec067;
    z-index: 2;
    background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0 0 no-repeat padding-box;
    opacity: 0;
    align-items: center;
    color: white;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    flex-direction: column;
}

.upload_title {
    cursor: pointer;
}

.round__shdow {
    width: 168px;
    height: 168px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
}


.card__round__shadow {
    width: 100px;
    height: 100px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
}


.main.main_setting::after {
    display: none;
}

.main.empty__trash::after {
    display: none;
}


.card__slider_not_value .rangeslider-vertical .rangeslider__handle-label {
    background: #E3E2E2 !important;
}

.card__slider_not_value .rangeslider-vertical .rangeslider__fill {
    background: #E3E2E2 !important;
}


input:-webkit-autofill,
input:-webkit-autofill:focus {
    -webkit-transition: background-color 600000s 0s, color 600000s 0s !important;
    transition: background-color 600000s 0s, color 600000s 0s !important;
}

/* open */


.nav.open {
    width: 272px;
}

.nav.open .logo {
    width: 200px;
}

.nav.open .logo__img {
    display: none;
}

.nav.open .logo__img__big {
    display: inline-block;
    width: 100%;
    height: 100%;
}

.nav.open .nav__link {
    width: 208px;
}

.nav.open .nav__link .nav__text {
    font-size: 20px;
    position: relative;
    opacity: 1;
    visibility: visible;
    color: #364048;
}

.main.open {
    padding-left: 325px;
}

.header.open {
    padding-left: 296px;
}


.horizontal_slid_nit_value .rangeslider-horizontal .rangeslider__handle-label {
    background: #E3E2E2 !important;
}

.card__risk__alert__not_number {
    color: #889096 !important;
}

.css-1s2u09g-control {
    border: none !important;
    background: none !important;
    /* border-bottom: 1px 1px 1px rgb(174 174 192) !important; */
    /* border-bottom: 1px solid rgb(174 174 192 / 20%) !important; */
    cursor: pointer !important;
}

.css-1okebmr-indicatorSeparator {
    background: none !important;
}

.css-2613qy-menu {
    background: none !important;
}

.btn_disabled {
    opacity: .5 !important;
}


/* Custom */
.dropdown__sub__body {
    /* z-index: 10; */
}

.form__content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.open_assets {
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2 !important;
}

/* 
.alerts__input__wrapper {
    margin-bottom: 22px !important;
} */

.alerts__input__wrapper {
    position: relative;
}

* {

    /* scrollbar-width: none !important; */
    /* Firefox implementation */

}

.delete_module {
    height: 260px;
    /* right: -100px; */
}

.delete_module .title {
    font-size: 19px;
    font-weight: 600;
    color: #364048;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
}

.delete_module .btn_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.delete_module .card__product__stake__amount__confirm {
    width: 40%;
}

.save__text {
    height: 100%;
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
}

.card__wallet__content {
    display: flex;
    justify-content: flex-start;
}

.ReactModal__Content .ReactModal__Content--after-open {
    padding: 0 !important;
}

.wallet__modal__container {
    padding-top: 105px;
}

.balance__block__top {
    cursor: auto !important;
}

.ntf_card_title {
    display: flex;
    margin: auto;
}


.delete_module .title__name {
    font-weight: 900;
}

.empty_main {
    border-color: #f0f0f3 !important;
    color: #C4C4C4 !important;
}

.open__modal {
    top: 388px !important;
}

.add__wallet__btn__plus__bg {
    margin: auto;
}


.card__round__shadow__defi__list {
    width: 55px;
    height: 53px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
    top: 23px;
    left: 23px;
}

.password__change__label {
    position: relative;
    padding: 0 20px !important;
    text-align: start !important;
    align-items: flex-start !important;
}

.password__input {
    border: none;
    width: calc(100% - 50px);
    outline: none;
    font-size: 18px;
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    background: none;
}


.success_message {
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    color: #214175;
    display: flex;
    justify-content: center;
    margin: 3px 0 5px 0;
    line-break: anywhere;
    font-weight: 600;
}

.card__product__green {
    color: #4DC7B5 !important;
}


.card__product__yellow {
    color: #EFB661 !important;
}

.card__product__red {
    color: #F27281 !important;
}

.card__product__white {
    color: #9CA3A8 !important;
}


.card__border__color__green {
    border-color: #4DC7B5 !important;
}

.card__border__color__yellow {
    border-color: #EFB661 !important;
}

.card__border__color__red {
    border-color: #F27281 !important;
}

.card__border__color__white {
    border-color: #9CA3A8 !important;
}


.aside__nth__title {
    font-size: 14px !important;
    line-height: 20px !important;

}

.user__info__name {
    border: none;
    background: none;
    outline: none;
}

.user__avatar {
    object-fit: cover;
}

.qr__opacity {
    opacity: 0 !important;
}

.uploda__user__image {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
}

.qr__logo__opacity {
    opacity: 0 !important;
    display: none !important;
}

.user__name {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 60px;
    white-space: nowrap;
}

.forgot__password__content {
    width: 285px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.forgot__passwors_text {
    cursor: pointer;
    font-weight: 500;
    line-height: 15px;
    font-size: 15px;
    color: #214175;
}

.clean__all {
    cursor: pointer;
    font-weight: 500;
    line-height: 15px;
    font-size: 15px;
    color: #214175;
    width: 200px;
    padding: 10px;
    margin-bottom: 21px;
}


.trash__delete__modal__content .card__product__stake__amount {
    left: 0;
    right: 0;
    margin: auto;
}


.approve_btn {
    margin: auto;
    justify-content: center !important;
}

.approves__modal {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    z-index: 9;
    position: absolute;
}

.requests__message {
    word-break: break-all;
    width: 85%;
    margin: 3px auto !important;
}

.login_requests__message {
    word-break: break-all;
    width: 65%;
    margin: 3px auto !important;
}

.psw_requests__message {
    word-break: break-all;
    width: 60%;
    margin: 3px auto !important;
    display: flex;
    justify-content: center;
}

.light__defi__zoom {
    position: absolute !important;
    left: 0 !important;
    right: 24px !important;
}

.PhoneInputInput {
    width: 100% !important;
    background-color: transparent !important;
    border: 0 !important;
    outline: none !important;
    font-size: 18px !important;
    line-height: 23px !important;
    transition: all 0.4s !important;
}

.PhoneInput {
    padding: 0 10px !important;
}


.settings_error_message {
    text-align: center;
    font-size: 13px;
    line-height: 23px;
    color: #be6161;
    display: flex;
    margin: 3px 0 5px 0;
    justify-content: center;
}


.view__icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    right: 10px;
    position: absolute;
}

.notificaten__password__content {
    position: relative;
    align-items: center;
    text-align: center;
    justify-content: center;

}

.notificaten__password__icon {
    position: absolute;
    right: 6px;
    align-items: center;
    text-align: center;
    justify-content: center;
    display: flex;
    margin: auto;
    top: 15px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.email__title {
    width: 380px;
}

.trash__error__modal,
.unstake__error__modal {
    width: 300px;
    min-height: 200px;
    height: fit-content;
    position: fixed;
    z-index: 99999999;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);
    border-radius: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

}


.unstake__error__modal {
    width: 303px;
    left: -19px;
}

.trash__error__modal__title,
.unstake__error__modal__title {
    font-size: 16px;
    line-height: 21px;
    width: 300px;
    word-break: break-all;
    padding: 0 10px;
    color: #364048;
    font-weight: 600;
}

.unstake__error__modal__title {
    width: unset;
}

.alert__midal {
    left: 0;
}

.trash__title__item {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
    height: 1.2em;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    margin: auto 0px;
}



.trash__zoom {
    top: 70px !important;
    /* left: 0 !important; */
    right: 60px !important;
    position: absolute !important;
    /* bottom: 0 !important; */
}

.close__card__content {
    position: absolute;
    right: 15px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 30px;
    width: 30px;
    z-index: 999;
}

.form__content__error {
    margin-bottom: 0 !important;
}


.password__message {
    width: 85%;
}

.accept_password__message {
    width: 75%;
    margin: 15px 0 !important;
}

.change_password__message {
    width: 79%;
}

.version__title {
    margin: 10px 20px;
}

.defi__card__unstake {
    word-break: unset !important;
}

.active__page__main__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
}

.active__page__main {
    background: #F0F0F3;
    box-shadow: -10px -10px 30px #ffffff, 10px 10px 30px rgb(174 174 192 / 40%);
    border-radius: 30px;
    width: 60%;
    padding: 20px 10px;
    position: relative;
}

.active_loading__layer {
    position: unset !important;
    width: unset !important;
    height: unset !important;
}

.alerts__input__wrapper div {
    display: flex !important;
    align-items: center !important;
}

.error_message {
    color: rgb(190, 97, 97) !important;
    align-items: center;
    text-align: center;
    display: flex;
    font-size: 14px;
    justify-content: center;
    font-weight: 500;
}

.light_defi_row {
    justify-content: center !important;
    align-items: center !important;

}


.card__nft__wrapper_content {
    justify-content: start !important;
    width: 100%;
    max-height: 200px;
    overflow: auto;
    min-height: auto;


}

.light_ntf_item_content {
    width: 100%;
    padding: 10px;
    /* height: 290px; */
}

.light_ntf_item {
    padding: 5px;
    cursor: pointer;
    color: #717679;
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 3px;
}

.light_ntf_item:hover {
    color: #1762A2 !important;
}

.card__nft__wrapper_content::-webkit-scrollbar {
    background-color: none !important;
    width: 0 !important;
}

.light_ntf_item_img {
    height: 20px;
    width: 20px;
    border-radius: 50px;
}

.light_ntf_item_span {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100px;
    height: 1.2em;
    white-space: nowrap;
}

.wallet__close__card {
    z-index: 9 !important;
    height: 15px;
}

.wallet__form__header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

}

.card__wallet__rates_input {
    border: none;
    background: none;
    outline: none;
    color: #889096;
    line-height: 26px;
    font-size: 14px;
    font-weight: 600;
}


.trash__card__title {
    margin: 0 !important;
}

.trash__card__row {
    margin-bottom: 8px !important;
}

.card__product__stake__block__light_defi {
    opacity: 0 !important;
}

.alert__input__modal {
    width: 300px;
    min-height: 200px;
    height: fit-content;
    position: absolute;
    z-index: 99999999;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);
    border-radius: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

    flex-direction: column;
}

.alert_btn_content {
    display: flex;
    width: 70%;
    justify-content: space-between;
    align-items: center;
}


.filter__icon {
    margin-right: -8px;
    cursor: pointer;
}

.chart__container {
    position: fixed;
    z-index: 999999;
    width: fit-content;
    height: fit-content;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.wallet__add {
    /* margin: auto !important; */
    width: 32px !important;
    height: 32px !important;
    position: absolute !important;
    top: 10px !important;
    left: 10px !important;
}

.adderss_input {
    width: 100% !important;
    font-size: 17px !important;

}

.wallet__address__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.address_input__wrapper {
    width: 100% !important;
    margin-bottom: 6px !important;
    padding: 0 23px 0 50px;
    font-size: 17px !important;

}

.wallet_address_content {
    position: relative;
    width: 96%;
    margin-left: 60px;
}

.addresses_items {
    display: flex;
    flex-direction: column;
    width: 100% !important;
}

.recucle__zoom_btn {
    margin-right: -45px !important;
}


.empty__trash_container .main:after {
    content: none !important;
    height: none !important;
}

.empty__trash_container .main .content {
    width: 100% !important;
}

.asset__list_filter {
    font-weight: 700 !important;
}

.assets_nav {
    display: flex;
    justify-content: space-between;
}

.WhitelistForm__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.alerts__input__wrapper__container {
    align-items: center;
    text-align: center;
    width: 370px;
    margin-bottom: 20px;
}

.light_ntf_item_information {
    display: flex;
    align-items: center;
}

.light_ntf_item_span {
    margin-left: 10px;
}

.chart__card__title {
    margin: 0 0 17px 0 !important;
    font-size: 17px !important;
}

.trash .card__product__title {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
    white-space: nowrap;
}

.ntf__filter__content {
    width: 100%;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    margin-bottom: 5px;
}

.ntf__filter__input {
    border: none;
    background: none;
    outline: none;
    font-size: 12px;
    line-height: 23px;
    font-weight: 500;
    color: #889096 !important;
    width: 100%;
    padding: 0 5px;
}

.light_ntf_item_isExist {
    background: #88909644 !important;
    border-radius: 24px !important;
}


.contract__address_main_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.contract__address_btn {
    width: 100px !important;
    font-size: 14px !important;
    height: 35px !important;
}

.contract__address_content {
    /* width: 320px; */
    height: 35px;
    width: 500px;
}

.chart__catent__value {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: auto;
}

.all_conections_ntf {
    width: 130px;
}


.page__loading__layer {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 999 !important;
}


.unstake__error_message {
    color: rgb(190, 97, 97);
    align-items: center;
    text-align: center;
    display: flex;
    font-size: 13px;
    justify-content: center;
    font-weight: 600;
    line-height: 15px;
    padding: 0 1pc;
}

.email__input__add {
    width: 280px !important;
    margin: 0 auto;
}

.line__chart {
    padding: 0 10px;
}

.limit__block__wrapper_container {
    position: relative;
}

.walletShildAccept {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 16px;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    border-radius: 16px;
    background-color: #f0f0f3;
    width: 540px;
    margin-top: 5px;
}

.wallet_accept__type__save {
    width: 100%;
    height: 32px;
    border-radius: 67px;
    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgb(174 174 192 / 40%);
    background-color: #214175;
    font-size: 15px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    border: 0;
}

.wallet_input_form {
    display: flex;
    flex-direction: column;
}

.wallet_input_form_title {
    text-decoration: none;
    color: #9CA3A8;
    font-weight: 600;
    font-size: 14px;
    border: none;
    outline: none;
    line-height: 23px;
    margin-bottom: 5px;
}

.wallet_input_form_input {
    border: none;
    outline: none;
    transition: all 0.4s;
    height: 40px;
    background: #F0F0F3;
    border-radius: 67px;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    display: flex;
    align-items: center;
    width: 100px;
    text-align: center;
    color: #9CA3A8;
    font-weight: 400;
    font-size: 13px;
}

.wallet_input_form_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    width: 400px;
    margin: 0 auto 15px;
}

.assets__wallet__type {
    position: absolute !important;
    z-index: 99;
}

.wallet__shild__card__header {
    align-items: center;
    justify-content: center;
    display: flex;
}


.rangeslider-vertical .rangeslider__handle {
    outline: none !important;
}

.rangeslider-horizontal .rangeslider__handle {
    outline: none !important;
}

.whitelist__close__card {
    top: 0 !important;
    right: 6px !important;
}



.open__trush {
    left: 28px !important;
    width: 210px !important;
}

.wallet__addresses__top__right {
    display: flex;
    justify-content: flex-end;
}

.wallet__first__type {
    top: 0;
}

.wallet__modal {
    padding: 0 24px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.wallet__remove {
    font-size: 47px;
    display: flex;
    margin-top: -12px;
    color: #2167A4;
}

.partner_img_item {
    object-fit: contain !important;
}


.partner__guard__title {
    font-size: 13px;
}


.asset__select__content {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}

.asset__select__content_span {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: left;
    font-size: 14px;
    margin: 5px 0;
}

.partner__cuard__title {
    color: #1890ff;
    margin-left: 10px;
}

.light__ntf__calc .ant-col-offset-12 {
    margin: 0 !important;
}

.ant-table-cell {
    padding: 10px 0px 10px 5px !important;
}

.chart__open__btn {
    position: absolute;
    left: 10px;
    cursor: pointer;
    top: 8px;
}

.chart__open__btn img {
    width: 30px;
    height: 30px;
}

.edit_asser__modal {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.calc__form {
    width: 50%;
}

.calc_modal_description {
    width: 50%;
    align-items: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
}

.calc_modal_description_title {
    font-weight: 600;
    font-size: 20px;
    font-family: 'Assistant', sans-serif;
}

.calc_modal_title {
    font-size: 14px;
    font-family: 'Assistant', sans-serif;
    line-height: 28px;
}

.diferent__title {
    color: #9575a9;
    font-weight: bold !important;
}

.platform__calc__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.platform__calc__content {
    margin-top: 140px;
}

.title__one {
    color: #9575a9;
    font-weight: bold !important;
}


.calc__modal {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
}

.asset__calculate_form_modal {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    /* border: 1px solid black; */
    width: 100%;
    font-size: 17px;
    font-weight: 600;
}

.asset__component__item {
    width: 46%;
}

.modal__item {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    /* border: 1px solid black; */
}


.asset__calculate_form_modal .ant-form-item {
    margin-bottom: 0px !important;
}

.stableCoin__content .ant-form-item-control-input-content {
    flex: none !important;
}

.edit__blochain__form {
    width: 40% !important;
}

.asset__delete__item__content {
    width: 100%;
}

.asset__delete__item__content ant-table-wrapper {
    width: 100% !important;
}


.dellete__asset__table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

.dellete__asset__table_td,
.dellete__asset__table_th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
}

.dellete__asset__table_tr:nth-child(even) {
    background-color: #dddddd;
}

.trash_asset__delete__item__content {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.45);
}

.trash_asset__delete__delete__btns {
    display: flex;
    align-items: center;
    text-align: center;
}

.restore__btn {
    margin-right: 10px;
}

.ant-list-empty-text {
    display: none;
}

.defi__shild__trash__title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
}

.restore_title {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    color: rgba(0, 0, 0, 100);
    margin: 0 10px;
}

.defi__shild__trash__symbol__title {
    margin-left: 5px !important;
}


.no_stable_coin_form .ant-form-item {
    margin: 0 !important;
}

.no_stable_coin_form b {
    color: #1890ff;
}


.calc__form__modal {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    margin-top: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.calc__form {
    width: 100%;
    align-items: center;
    text-align: center;
}

.ant-tabs-nav-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.ant-tabs-tab {
    width: 100%;
    justify-content: center;
}

.custom-scroll .ant-table-body {
    /* Custom scrollbar track */
    scrollbar-color: #d4d4d4 #f4f4f4;
    scrollbar-width: thin;
}

.custom-scroll {
    width: 80vw;
}

/* Custom scrollbar styles for WebKit browsers */
.custom-scroll .ant-table-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.custom-scroll .ant-table-body::-webkit-scrollbar-track {
    background: #f4f4f4;
}

.custom-scroll .ant-table-body::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
    border: 2px solid #f4f4f4;
}

.custom-scroll .ant-table-body::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}

.editable-field {
    width: 98%;
}

.custom-checkbox {
    vertical-align: middle;
    margin-right: 20px;
}

.custom-checkbox .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border: 2px solid #8c8c8c;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: rgb(61, 162, 194);
    border-color: rgb(61, 162, 194);

}

.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff;
}

.custom-checkbox .ant-checkbox:hover .ant-checkbox-inner {
    border-color: rgb(61, 162, 194);

}

.custom-checkbox .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: rgb(61, 162, 194);
}

.ant-space-align-center {
    align-items: self-end;
}

.list-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    padding: 10px 16px;
    border-bottom: 1px solid #ddd;
}

.list-header-title {
    flex: 8 1;
}

.list-header-checkbox {
    flex: 1 1;
    text-align: right;
}

.list-header-actions {
    flex: 2 1;
    text-align: right;
}

.has_automatic {
    color: red;
    margin-left: 10px;
    width: 18px;
    height: 18px;
    display: inline-block;
    border: 1px solid red;
    border-radius: 16px;
    text-align: center;
    line-height: 18px;
}

.ant-popover-inner-content {
    padding: 12px 16px 35px 15px !important;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:-inset-2::after{
  content: var(--tw-content);
  inset: -0.5rem;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:w-\\[2px\\]::after{
  content: var(--tw-content);
  width: 2px;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.focus-within\\:relative:focus-within{
  position: relative;
}

.focus-within\\:z-20:focus-within{
  z-index: 20;
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-sidebar-accent:hover{
  background-color: hsl(var(--sidebar-accent));
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-800:hover{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-sidebar-accent-foreground:hover{
  color: hsl(var(--sidebar-accent-foreground));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover{
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:after\\:bg-sidebar-border:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--sidebar-border));
}

.focus\\:border-blue-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-sidebar-ring:focus-visible{
  --tw-ring-color: hsl(var(--sidebar-ring));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:bg-sidebar-accent:active{
  background-color: hsl(var(--sidebar-accent));
}

.active\\:text-sidebar-accent-foreground:active{
  color: hsl(var(--sidebar-accent-foreground));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100{
  opacity: 1;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer\\/menu-button:hover ~ .peer-hover\\/menu-button\\:text-sidebar-accent-foreground{
  color: hsl(var(--sidebar-accent-foreground));
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar:has([data-variant=inset]){
  background-color: hsl(var(--sidebar-background));
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.group\\/menu-item:has([data-sidebar=menu-action]) .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8{
  padding-right: 2rem;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"]{
  pointer-events: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"]{
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[state\\=active\\]\\:border-green-600[data-state="active"]{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}

.data-\\[state\\=active\\]\\:border-red-600[data-state="active"]{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}

.data-\\[state\\=active\\]\\:border-yellow-600[data-state="active"]{
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity, 1));
}

.data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"]{
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[active\\]\\:bg-accent\\/50[data-active]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=active\\]\\:bg-white[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"]{
  font-weight: 500;
}

.data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"]{
  color: hsl(var(--sidebar-accent-foreground));
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-blue-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=active\\]\\:text-green-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=active\\]\\:text-red-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=active\\]\\:text-yellow-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"]{
  opacity: 1;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent:hover[data-state="open"]{
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground:hover[data-state="open"]{
  color: hsl(var(--sidebar-accent-foreground));
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{
  left: calc(var(--sidebar-width) * -1);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{
  right: calc(var(--sidebar-width) * -1);
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4{
  right: -1rem;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0{
  left: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8{
  margin-top: -2rem;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden{
  display: none;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!size-8{
  width: 2rem !important;
  height: 2rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[--sidebar-width-icon\\]{
  width: var(--sidebar-width-icon);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\]{
  width: calc(var(--sidebar-width-icon) + 1rem);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\]{
  width: calc(var(--sidebar-width-icon) + 1rem + 2px);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0{
  width: 0px;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden{
  overflow: hidden;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg{
  border-radius: var(--radius);
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border{
  border-width: 1px;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r{
  border-right-width: 1px;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l{
  border-left-width: 1px;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border-sidebar-border{
  border-color: hsl(var(--sidebar-border));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-0{
  padding: 0px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-2{
  padding: 0.5rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0{
  opacity: 0;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after{
  content: var(--tw-content);
  left: 100%;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:bg-sidebar:hover{
  background-color: hsl(var(--sidebar-background));
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5{
  top: 0.375rem;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5{
  top: 0.625rem;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1{
  top: 0.25rem;
}

.peer[data-variant="inset"] ~ .peer-data-\\[variant\\=inset\\]\\:min-h-\\[calc\\(100svh-theme\\(spacing\\.4\\)\\)\\]{
  min-height: calc(100svh - 1rem);
}

.peer\\/menu-button[data-active="true"] ~ .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground{
  color: hsl(var(--sidebar-accent-foreground));
}

.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-divide-opacity, 1));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.dark\\:bg-blue-900\\/50:is(.dark *){
  background-color: rgb(30 58 138 / 0.5);
}

.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800\\/50:is(.dark *){
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900\\/50:is(.dark *){
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:bg-green-900\\/30:is(.dark *){
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-red-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900\\/30:is(.dark *){
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-red-900\\/50:is(.dark *){
  background-color: rgb(127 29 29 / 0.5);
}

.dark\\:bg-yellow-900\\/30:is(.dark *){
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:bg-blue-900\\/40:hover:is(.dark *){
  background-color: rgb(30 58 138 / 0.4);
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800\\/50:hover:is(.dark *){
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:hover\\:bg-green-900\\/20:hover:is(.dark *){
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:hover\\:bg-red-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:hover\\:bg-red-900\\/40:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.4);
}

@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:text-left{
    text-align: left;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:relative{
    position: relative;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:opacity-0{
    opacity: 0;
  }

  .after\\:md\\:hidden::after{
    content: var(--tw-content);
    display: none;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2{
    margin: 0.5rem;
  }

  .peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:ml-2{
    margin-left: 0.5rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0{
    margin-left: 0px;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow{
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1024px){

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }
}

@media (min-width: 1280px){

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>button\\]\\:hidden>button{
  display: none;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg{
  height: 0.625rem;
}

.\\[\\&\\>svg\\]\\:h-3>svg{
  height: 0.75rem;
}

.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg{
  width: 0.625rem;
}

.\\[\\&\\>svg\\]\\:w-3>svg{
  width: 0.75rem;
}

.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg{
  color: hsl(var(--muted-foreground));
}

.\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground>svg{
  color: hsl(var(--sidebar-accent-foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text{
  fill: hsl(var(--muted-foreground));
}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc']{
  stroke: hsl(var(--border) / 0.5);
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff']{
  stroke: transparent;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc']{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector{
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor{
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc']{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff']{
  stroke: transparent;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2{
  right: -0.5rem;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize{
  cursor: e-resize;
}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:cursor-w-resize{
  cursor: w-resize;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2{
  left: -0.5rem;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize{
  cursor: w-resize;
}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:cursor-e-resize{
  cursor: e-resize;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;QAAA,uBAAc;QAAd,uBAAc;QAAd,iBAAc;QAAd,4BAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,kBAAc;QAAd,8BAAc;QAAd,uBAAc;QAAd,+BAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,4BAAc;QAAd,4BAAc;QAAd,kCAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,iBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,qBAAc;QAAd,gBAAc;QAAd,8BAAc;QAAd,oCAAc;QAAd,+BAAc;QAAd,sCAAc;QAAd,gCAAc;QAAd,yCAAc;QAAd,6BAAc;QAAd,iCAAc;IAAA;;AAAd;QAAA,uBAAc;QAAd,sBAAc;QAAd,iBAAc;QAAd,2BAAc;QAAd,oBAAc;QAAd,8BAAc;QAAd,mBAAc;QAAd,6BAAc;QAAd,uBAAc;QAAd,gCAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,6BAAc;QAAd,4BAAc;QAAd,kCAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,kBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,kCAAc;QAAd,oCAAc;QAAd,kCAAc;QAAd,uCAAc;QAAd,gCAAc;QAAd,2CAAc;QAAd,gCAAc;QAAd,iCAAc;IAAA;;AAAd;EAAA,gCAAc;EAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAGnB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmEG;;AAyFH;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;;AAGA;IACI;iBACa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA,UAAU;AACV,mBAAmB;AACnB,6BAA6B;AAC7B,yBAAyB;AACzB,yBAAyB;AACzB,oBAAoB;AACpB,KAAK;;AAEL;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA,eAAe;AACf,mBAAmB;AACnB,oCAAoC;AACpC,IAAI;;AAEJ;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;AACtB;;;AAGA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,2GAA2G;IAC3G,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,sGAAsG;IACtG,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,2GAA2G;IAC3G,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,sGAAsG;IACtG,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;;;GAGG;AACH;IACI,SAAS;IACT;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;;AAGA;IACI;iBACa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;;AAGA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,2GAA2G;AAC/G;;;AAGA,SAAS;;AAET;IACI,qBAAqB;IACrB,wBAAwB;IACxB,2GAA2G;IAC3G,8BAA8B;IAC9B,8BAA8B;IAC9B,mCAAmC;IACnC,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;IAC7B,wGAAwG;AAC5G;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6EAA6E;IAC7E,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;;IAEI,4DAA4D;IAC5D,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iFAAiF;IACjF,8BAA8B;IAC9B,8BAA8B;;;AAGlC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,kDAAkD;IAClD,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,mEAAmE;IACnE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,6FAA6F;AACjG;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA,mDAAmD;AACnD;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IAIb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,0DAA0D;IAC1D,UAAU;IACV,qIAAqI;IACrI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAnB1B;;AAsBA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;;IAEI,4EAAoE;IAApE,oEAAoE;AACxE;;AAEA,SAAS;;;AAGT;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,4DAA4D;IAC5D,gEAAgE;IAChE,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA,WAAW;AACX;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;;;GAGG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;;IAEI,sCAAsC;IACtC,2BAA2B;;AAE/B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,0BAA0B;IAC1B,4BAA4B;;AAEhC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,oBAAoB;IACpB,wBAAwB;IACxB,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;AAE3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,uEAAuE;IACvE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;AAE3B;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2EAA2E;IAC3E,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;;AAElC;;;AAGA;IACI,iCAAiC;IACjC,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;;;AAGpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,uEAAuE;IACvE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;IAEvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;;AAE9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;;AAE9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gGAAgG;IAChG,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,gGAAgG;IAChG,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wEAAwE;IACxE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gGAAgG;IAChG,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;;;AAIA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA,gDAAgD;AAChD;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;;AAEnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;AAC3C;;AAjuEA;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,mBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED,QAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,iDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,iDAiuEC;EAjuED,qDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,gFAiuEC;EAjuED,oGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,2GAiuEC;EAjuED,yGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,2GAiuEC;EAjuED,yGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,2GAiuEC;EAjuED,yGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,2GAiuEC;EAjuED,yGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,+EAiuEC;EAjuED,mGAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,yBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,yBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,gDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,iDAiuEC;EAjuED;AAiuEC;;AAjuED;;EAAA;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;AAAA;;AAjuED;EAAA;AAiuEC;;AAjuED;;EAAA;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;AAAA;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,0EAiuEC;EAjuED,8FAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED,yBAiuEC;EAjuED,2BAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,+BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED,yBAiuEC;EAjuED,2BAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,+BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED,yBAiuEC;EAjuED,2BAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,+BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,wBAiuEC;EAjuED,yBAiuEC;EAjuED,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,wBAiuEC;EAjuED,yBAiuEC;EAjuED,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,wBAiuEC;EAjuED,yBAiuEC;EAjuED,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED,yBAiuEC;EAjuED,0BAiuEC;EAjuED,wBAiuEC;EAjuED,yBAiuEC;EAjuED,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,mBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,mBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,0EAiuEC;EAjuED,8FAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,0BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;;EAAA;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,uBAiuEC;IAjuED,sDAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA,uBAiuEC;IAjuED,oDAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA,uBAiuEC;IAjuED,2DAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;AAAA;;AAjuED;;EAAA;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,qBAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,uBAiuEC;IAjuED,oDAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,mBAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA,mBAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,0BAiuEC;IAjuED;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA,0EAiuEC;IAjuED,8FAiuEC;IAjuED;EAiuEC;AAAA;;AAjuED;;EAAA;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;;EAjuED;IAAA;EAiuEC;AAAA;;AAjuED;;EAAA;IAAA;EAiuEC;AAAA;;AAjuED;EAAA,kDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,iDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,iDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kDAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,gBAiuEC;EAjuED,uBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,gBAiuEC;EAjuED,oBAiuEC;EAjuED,4BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,sBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,WAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,mBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,8BAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,qBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,kBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA,oBAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA,WAiuEC;EAjuED;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC;;AAjuED;EAAA;AAiuEC","sourcesContent":["@import '~antd/dist/antd.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n/* :root {\n  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;\n  line-height: 1.5;\n  font-weight: 400;\n\n  color-scheme: light dark;\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #242424;\n\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  font-weight: 500;\n  color: #646cff;\n  text-decoration: inherit;\n}\na:hover {\n  color: #535bf2;\n}\n\nbody {\n  margin: 0;\n  display: flex;\n  place-items: center;\n  min-width: 320px;\n  min-height: 100vh;\n}\n\nh1 {\n  font-size: 3.2em;\n  line-height: 1.1;\n}\n\nbutton {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 0.6em 1.2em;\n  font-size: 1em;\n  font-weight: 500;\n  font-family: inherit;\n  background-color: #1a1a1a;\n  cursor: pointer;\n  transition: border-color 0.25s;\n}\nbutton:hover {\n  border-color: #646cff;\n}\nbutton:focus,\nbutton:focus-visible {\n  outline: 4px auto -webkit-focus-ring-color;\n}\n\n@media (prefers-color-scheme: light) {\n  :root {\n    color: #213547;\n    background-color: #ffffff;\n  }\n  a:hover {\n    color: #747bff;\n  }\n  button {\n    background-color: #f9f9f9;\n  }\n} */\n\n\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --foreground: 0 0% 3.9%;\n        --card: 0 0% 100%;\n        --card-foreground: 0 0% 3.9%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 0 0% 3.9%;\n        --primary: 0 0% 9%;\n        --primary-foreground: 0 0% 98%;\n        --secondary: 0 0% 96.1%;\n        --secondary-foreground: 0 0% 9%;\n        --muted: 0 0% 96.1%;\n        --muted-foreground: 0 0% 45.1%;\n        --accent: 0 0% 96.1%;\n        --accent-foreground: 0 0% 9%;\n        --destructive: 0 84.2% 60.2%;\n        --destructive-foreground: 0 0% 98%;\n        --border: 0 0% 89.8%;\n        --input: 0 0% 89.8%;\n        --ring: 0 0% 3.9%;\n        --chart-1: 12 76% 61%;\n        --chart-2: 173 58% 39%;\n        --chart-3: 197 37% 24%;\n        --chart-4: 43 74% 66%;\n        --chart-5: 27 87% 67%;\n        --radius: 0.5rem;\n        --sidebar-background: 0 0% 98%;\n        --sidebar-foreground: 240 5.3% 26.1%;\n        --sidebar-primary: 240 5.9% 10%;\n        --sidebar-primary-foreground: 0 0% 98%;\n        --sidebar-accent: 240 4.8% 95.9%;\n        --sidebar-accent-foreground: 240 5.9% 10%;\n        --sidebar-border: 220 13% 91%;\n        --sidebar-ring: 217.2 91.2% 59.8%;\n    }\n\n    .dark {\n        --background: 0 0% 3.9%;\n        --foreground: 0 0% 98%;\n        --card: 0 0% 3.9%;\n        --card-foreground: 0 0% 98%;\n        --popover: 0 0% 3.9%;\n        --popover-foreground: 0 0% 98%;\n        --primary: 0 0% 98%;\n        --primary-foreground: 0 0% 9%;\n        --secondary: 0 0% 14.9%;\n        --secondary-foreground: 0 0% 98%;\n        --muted: 0 0% 14.9%;\n        --muted-foreground: 0 0% 63.9%;\n        --accent: 0 0% 14.9%;\n        --accent-foreground: 0 0% 98%;\n        --destructive: 0 62.8% 30.6%;\n        --destructive-foreground: 0 0% 98%;\n        --border: 0 0% 14.9%;\n        --input: 0 0% 14.9%;\n        --ring: 0 0% 83.1%;\n        --chart-1: 220 70% 50%;\n        --chart-2: 160 60% 45%;\n        --chart-3: 30 80% 55%;\n        --chart-4: 280 65% 60%;\n        --chart-5: 340 75% 55%;\n        --sidebar-background: 240 5.9% 10%;\n        --sidebar-foreground: 240 4.8% 95.9%;\n        --sidebar-primary: 224.3 76.3% 48%;\n        --sidebar-primary-foreground: 0 0% 100%;\n        --sidebar-accent: 240 3.7% 15.9%;\n        --sidebar-accent-foreground: 240 4.8% 95.9%;\n        --sidebar-border: 240 3.7% 15.9%;\n        --sidebar-ring: 217.2 91.2% 59.8%;\n    }\n}\n\n\n\n@layer base {\n    * {\n        @apply border-border outline-ring/50;\n    }\n\n    body {\n        @apply bg-background text-foreground;\n    }\n}\n\n.ant-modal-confirm-body-wrapper {\n    width: 100%;\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n        monospace;\n}\n\np {\n    margin: 0;\n}\n\n/*#root {*/\n/*  display: flex;*/\n/*  justify-content: center;*/\n/*  align-items: center;*/\n/*  !* height: 100vh; *!*/\n/*  margin: 20px 0;*/\n/*};*/\n\n.App {\n    justify-content: center;\n    align-items: center;\n    width: 45%;\n}\n\n.ant-modal-body {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n\n.big_container {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background-color: #f3f6fa;\n    /*background-color: var(--clr);*/\n    /*align-items: center;*/\n    padding: 20px;\n}\n\n.header_box {\n    display: flex;\n    justify-content: end\n}\n\n.main_box {\n    display: flex;\n    width: 85%;\n}\n\n.main_box_right {\n    padding: 20px;\n    width: 100%;\n}\n\n.main_box_right_header {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    /*margin-bottom: 20px;*/\n}\n\n\n.tabs_container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin: 10px 30px\n}\n\n/*.top_header{*/\n/*  display: flex;*/\n/*  justify-content: space-between;*/\n/*}*/\n\n.table_component_container {\n    padding: 20px;\n}\n\n.sidebar_box {\n    width: 256px;\n}\n\n.tab_pane_text {\n    font-size: 18px;\n    font-weight: 500;\n    padding: 25px 25px 0 25px;\n}\n\n.tab_pane_deFi_shield {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n/* .demo-loadmore-list {\n    min-height: 700px;\n} */\n\n.card__product__yellow {\n    color: #EFB661 !important;\n}\n\n.card__product__green {\n    color: #4DC7B5 !important;\n}\n\n.card__product__red {\n    color: #F27281 !important;\n}\n\n.card__product__white {\n    color: white !important;\n}\n\n\n.card__risk__chart__min__wrapper {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n}\n\n.user_access_btn {\n    background: #11CC7A;\n    border-radius: 5px;\n    padding: 0px 15px;\n    border: none;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #FFFFFF;\n    /*margin-right:10px;*/\n    cursor: pointer;\n    height: 30px;\n    min-width: 80px;\n}\n\n.user_access_btn:hover,\n.user_access_btn:focus {\n    background: #11CC7A;\n    color: #FFFFFF;\n}\n\n.user_access_text {\n    color: #28B663;\n    /*pointer-events: none;*/\n}\n\n.user_unaccess_text {\n    color: red;\n    margin-left: 10px;\n}\n\n\n.margin_right {\n    margin-right: 15px;\n}\n\n\n/* From uiverse.io */\n.delete_btn {\n    width: 90px;\n    height: 30px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n    background: #e62222;\n}\n\n.delete_btn,\n.delete_btn span {\n    transition: 200ms;\n}\n\n.delete_btn .text {\n    transform: translateX(10px);\n    color: white;\n    font-weight: bold;\n}\n\n.delete_btn .icon {\n    position: absolute;\n    border-left: 1px solid #c41b1b;\n    transform: translateX(60px);\n    height: 20px;\n    width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.deFi_shield_connections_container {\n    width: 100%;\n}\n\n.delete_btn svg {\n    width: 15px;\n    fill: #eee;\n}\n\n.delete_btn:hover {\n    background: #ff3636;\n}\n\n.delete_btn:hover .text {\n    color: transparent;\n}\n\n.delete_btn:hover .icon {\n    width: 90px;\n    border-left: none;\n    transform: translateX(0);\n}\n\n.delete_btn:focus {\n    outline: none;\n}\n\n.delete_btn:active .icon svg {\n    transform: scale(0.8);\n}\n\n.user_shield_box {\n    display: flex;\n    justify-content: space-between;\n    align-content: center;\n    flex-wrap: wrap;\n}\n\n.user_shield_box_block {\n    width: 200px;\n    display: flex;\n    align-content: center;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n\n.user_shield_box_block_text {\n    color: #1890ff;\n    font-size: 20px;\n}\n\n.user_shield_box_block_cancel {\n    border-radius: 5px;\n    padding: 0 15px;\n    border: none;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #FFFFFF;\n    /*margin-right:10px;*/\n    cursor: pointer;\n    height: 30px;\n    background: #e62222;\n    min-width: 80px;\n}\n\n.user_shield_box_block_cancel:hover,\n.user_shield_box_block_cancel:focus {\n    background: #e62222;\n    color: #FFFFFF;\n}\n\n\n.no_date_text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 26px\n}\n\n\n.slider_box {\n    position: absolute;\n    bottom: 4px;\n}\n\n.tab_title_box {\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n}\n\n.slider_box>.ant-slider-rail {\n    width: 8px !important;\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n}\n\n.slider_box>.ant-slider-track {\n    position: absolute;\n    height: 4px;\n    background-color: #F27281 !important;\n    transition: background-color 0.3s;\n    width: 8px !important;\n    border-radius: 88px;\n\n}\n\n.slider_box>.ant-slider-handle {\n    width: 20px !important;\n    height: 20px !important;\n    border-radius: 50% !important;\n    box-shadow: inset 2px 0 5px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;\n    background: #F27281;\n    border: 3px solid #d0d0dc;\n}\n\n\n.slider_box_auto_unstacking {\n    position: absolute;\n    bottom: 4px;\n}\n\n.tab_title_box {\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n}\n\n.slider_box_auto_unstacking>.ant-slider-rail {\n    width: 8px !important;\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n}\n\n.slider_box_auto_unstacking>.ant-slider-track {\n    position: absolute;\n    height: 4px;\n    background-color: #385483 !important;\n    transition: background-color 0.3s;\n    width: 8px !important;\n    border-radius: 88px;\n\n}\n\n.slider_box_auto_unstacking>.ant-slider-handle {\n    width: 20px !important;\n    height: 20px !important;\n    border-radius: 50% !important;\n    box-shadow: inset 2px 0 5px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;\n    background: #385483;\n    border: 3px solid #d0d0dc;\n}\n\n\n@media (max-width: 1024px) {\n    .main_box {\n        flex-direction: column;\n    }\n\n    .sidebar_box {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .tabs_container {\n        margin: 0;\n    }\n\n    .table_component_container {\n        padding: 0;\n    }\n}\n\n.error_container {\n    align-items: center;\n    text-align: center;\n    padding: 5px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ff4d4f;\n}\n\n.score__continer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n}\n\n.score__line {\n    font-size: 20px;\n    font-weight: 900;\n    color: black;\n    margin: 0 10px;\n    display: flex;\n    /* height: 55px; */\n}\n\n.asset__risk__calculate__modal {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.asset__risk__calculate__form__content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.asset__risk__calculate__descriprion__content {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    font-size: 15px;\n}\n\n.calculate__buttons {\n    display: flex;\n}\n\n.platform__btn {\n    margin: 0 10px;\n}\n\n.score__item {\n    display: flex;\n    margin: 5px 0;\n}\n\n/* \n.component__item{\n    border-bottom: 1px solid #f0f0f0;    \n} */\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n        monospace;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    scroll-behavior: smooth;\n    /* font-size: $fz; */\n}\n\n\n.ReactModal__Overlay {\n    background: none !important;\n    z-index: 9 !important;\n}\n\n.card__product__stake_active {\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n}\n\n\n/*range */\n\n.rangeslider-vertical {\n    width: 8px !important;\n    height: 133px !important;\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n    /* position: absolute !important; */\n    left: 5px !important;\n    top: 0 !important;\n    margin: 0 !important;\n}\n\n.rangeslider {\n    margin: 2px 0 !important;\n}\n\n.rangeslider-vertical .rangeslider__handle-label {\n\n    width: 16px !important;\n    display: flex !important;\n    height: 16px !important;\n    border-radius: 50% !important;\n    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;\n}\n\n.card__slider .rangeslider-vertical .rangeslider__handle-label {\n    background: #F27281 !important;\n}\n\n.rangeslider-vertical .rangeslider__handle {\n    width: 27px !important;\n    height: 27px !important;\n    background: #F0F0F3;\n    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgb(54 54 77 / 40%) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    border-radius: 50% !important;\n    position: absolute !important;\n    left: -9px !important;\n    cursor: pointer !important;\n}\n\n.rangeslider-vertical .rangeslider__fill {\n\n    box-shadow: inset 3px 3px 3px rgb(64 64 80 / 33%) !important;\n    border-radius: 0px 0px 20px 20px !important;\n}\n\n.card__slider .rangeslider-vertical .rangeslider__fill {\n    background: #F27281 !important;\n}\n\n.rangeslider__labels {\n    display: none;\n}\n\n.rangeslider-horizontal {\n    width: 105px !important;\n    height: 8px !important;\n    box-shadow: inset 3px 3px 3px #aeaec033, inset -3px -3px 3px #ffffffb2 !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n\n\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n    height: 100% !important;\n    background: #F27281 !important;\n    box-shadow: inset 3px 3px 3px #40405053 !important;\n    border-radius: 20px 0 0 20px !important;\n    position: absolute !important;\n    left: 0 !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle {\n    width: 24px !important;\n    height: 24px !important;\n    background: #F0F0F3 !important;\n    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px #36364d67 !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    border-radius: 50% !important;\n    cursor: pointer !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle-label {\n    background: #F27281;\n    width: 16px;\n    display: flex;\n    height: 16px;\n    border-radius: 50%;\n    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%);\n}\n\n.rangeslider__handle::after {\n    display: none !important;\n}\n\n.current__card .rangeslider-horizontal {\n    width: 105px;\n}\n\n\n/* CUSTOM CSS TO CENTER PERCENTAGE IN PROGRESSBAR */\n.card__risk__chart__min__wrapper,\n.card__risk__chart__min__wrapper_aside {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n}\n\n.card__risk__chart__min__wrapper__defi__list {\n    top: 50% !important;\n}\n\n.card__risk__chart__min__wrapper_aside {\n    top: 35% !important;\n}\n\n.qr__logo {\n    width: 100px;\n    height: 100px;\n    opacity: 1;\n    display: flex;\n    margin: 0 auto 20px;\n}\n\n.selected__type {\n    border: 1px solid red;\n}\n\n\ninput[type=\"file\"] {\n    display: none;\n    cursor: pointer;\n}\n\n.upload__content {\n    display: flex;\n}\n\n.upload__content {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    box-shadow: -8px -8px 15px #ffffff, 8px 8px 15px #aeaec067;\n    z-index: 2;\n    background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0 0 no-repeat padding-box;\n    opacity: 0;\n    align-items: center;\n    color: white;\n    justify-content: center;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    flex-direction: column;\n}\n\n.upload_title {\n    cursor: pointer;\n}\n\n.round__shdow {\n    width: 168px;\n    height: 168px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n}\n\n\n.card__round__shadow {\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n}\n\n\n.main.main_setting::after {\n    display: none;\n}\n\n.main.empty__trash::after {\n    display: none;\n}\n\n\n.card__slider_not_value .rangeslider-vertical .rangeslider__handle-label {\n    background: #E3E2E2 !important;\n}\n\n.card__slider_not_value .rangeslider-vertical .rangeslider__fill {\n    background: #E3E2E2 !important;\n}\n\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n    transition: background-color 600000s 0s, color 600000s 0s !important;\n}\n\n/* open */\n\n\n.nav.open {\n    width: 272px;\n}\n\n.nav.open .logo {\n    width: 200px;\n}\n\n.nav.open .logo__img {\n    display: none;\n}\n\n.nav.open .logo__img__big {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n\n.nav.open .nav__link {\n    width: 208px;\n}\n\n.nav.open .nav__link .nav__text {\n    font-size: 20px;\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    color: #364048;\n}\n\n.main.open {\n    padding-left: 325px;\n}\n\n.header.open {\n    padding-left: 296px;\n}\n\n\n.horizontal_slid_nit_value .rangeslider-horizontal .rangeslider__handle-label {\n    background: #E3E2E2 !important;\n}\n\n.card__risk__alert__not_number {\n    color: #889096 !important;\n}\n\n.css-1s2u09g-control {\n    border: none !important;\n    background: none !important;\n    /* border-bottom: 1px 1px 1px rgb(174 174 192) !important; */\n    /* border-bottom: 1px solid rgb(174 174 192 / 20%) !important; */\n    cursor: pointer !important;\n}\n\n.css-1okebmr-indicatorSeparator {\n    background: none !important;\n}\n\n.css-2613qy-menu {\n    background: none !important;\n}\n\n.btn_disabled {\n    opacity: .5 !important;\n}\n\n\n/* Custom */\n.dropdown__sub__body {\n    /* z-index: 10; */\n}\n\n.form__content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.open_assets {\n    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2 !important;\n}\n\n/* \n.alerts__input__wrapper {\n    margin-bottom: 22px !important;\n} */\n\n.alerts__input__wrapper {\n    position: relative;\n}\n\n* {\n\n    /* scrollbar-width: none !important; */\n    /* Firefox implementation */\n\n}\n\n.delete_module {\n    height: 260px;\n    /* right: -100px; */\n}\n\n.delete_module .title {\n    font-size: 19px;\n    font-weight: 600;\n    color: #364048;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.delete_module .btn_content {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.delete_module .card__product__stake__amount__confirm {\n    width: 40%;\n}\n\n.save__text {\n    height: 100%;\n    width: 100%;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.card__wallet__content {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.ReactModal__Content .ReactModal__Content--after-open {\n    padding: 0 !important;\n}\n\n.wallet__modal__container {\n    padding-top: 105px;\n}\n\n.balance__block__top {\n    cursor: auto !important;\n}\n\n.ntf_card_title {\n    display: flex;\n    margin: auto;\n}\n\n\n.delete_module .title__name {\n    font-weight: 900;\n}\n\n.empty_main {\n    border-color: #f0f0f3 !important;\n    color: #C4C4C4 !important;\n}\n\n.open__modal {\n    top: 388px !important;\n}\n\n.add__wallet__btn__plus__bg {\n    margin: auto;\n}\n\n\n.card__round__shadow__defi__list {\n    width: 55px;\n    height: 53px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n    top: 23px;\n    left: 23px;\n}\n\n.password__change__label {\n    position: relative;\n    padding: 0 20px !important;\n    text-align: start !important;\n    align-items: flex-start !important;\n}\n\n.password__input {\n    border: none;\n    width: calc(100% - 50px);\n    outline: none;\n    font-size: 18px;\n    line-height: 25px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    background: none;\n}\n\n\n.success_message {\n    text-align: center;\n    font-size: 18px;\n    line-height: 26px;\n    color: #214175;\n    display: flex;\n    justify-content: center;\n    margin: 3px 0 5px 0;\n    line-break: anywhere;\n    font-weight: 600;\n}\n\n.card__product__green {\n    color: #4DC7B5 !important;\n}\n\n\n.card__product__yellow {\n    color: #EFB661 !important;\n}\n\n.card__product__red {\n    color: #F27281 !important;\n}\n\n.card__product__white {\n    color: #9CA3A8 !important;\n}\n\n\n.card__border__color__green {\n    border-color: #4DC7B5 !important;\n}\n\n.card__border__color__yellow {\n    border-color: #EFB661 !important;\n}\n\n.card__border__color__red {\n    border-color: #F27281 !important;\n}\n\n.card__border__color__white {\n    border-color: #9CA3A8 !important;\n}\n\n\n.aside__nth__title {\n    font-size: 14px !important;\n    line-height: 20px !important;\n\n}\n\n.user__info__name {\n    border: none;\n    background: none;\n    outline: none;\n}\n\n.user__avatar {\n    object-fit: cover;\n}\n\n.qr__opacity {\n    opacity: 0 !important;\n}\n\n.uploda__user__image {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 10px;\n}\n\n.qr__logo__opacity {\n    opacity: 0 !important;\n    display: none !important;\n}\n\n.user__name {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 60px;\n    white-space: nowrap;\n}\n\n.forgot__password__content {\n    width: 285px;\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n}\n\n.forgot__passwors_text {\n    cursor: pointer;\n    font-weight: 500;\n    line-height: 15px;\n    font-size: 15px;\n    color: #214175;\n}\n\n.clean__all {\n    cursor: pointer;\n    font-weight: 500;\n    line-height: 15px;\n    font-size: 15px;\n    color: #214175;\n    width: 200px;\n    padding: 10px;\n    margin-bottom: 21px;\n}\n\n\n.trash__delete__modal__content .card__product__stake__amount {\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n\n.approve_btn {\n    margin: auto;\n    justify-content: center !important;\n}\n\n.approves__modal {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto;\n    z-index: 9;\n    position: absolute;\n}\n\n.requests__message {\n    word-break: break-all;\n    width: 85%;\n    margin: 3px auto !important;\n}\n\n.login_requests__message {\n    word-break: break-all;\n    width: 65%;\n    margin: 3px auto !important;\n}\n\n.psw_requests__message {\n    word-break: break-all;\n    width: 60%;\n    margin: 3px auto !important;\n    display: flex;\n    justify-content: center;\n}\n\n.light__defi__zoom {\n    position: absolute !important;\n    left: 0 !important;\n    right: 24px !important;\n}\n\n.PhoneInputInput {\n    width: 100% !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    outline: none !important;\n    font-size: 18px !important;\n    line-height: 23px !important;\n    transition: all 0.4s !important;\n}\n\n.PhoneInput {\n    padding: 0 10px !important;\n}\n\n\n.settings_error_message {\n    text-align: center;\n    font-size: 13px;\n    line-height: 23px;\n    color: #be6161;\n    display: flex;\n    margin: 3px 0 5px 0;\n    justify-content: center;\n}\n\n\n.view__icon {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    right: 10px;\n    position: absolute;\n}\n\n.notificaten__password__content {\n    position: relative;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n}\n\n.notificaten__password__icon {\n    position: absolute;\n    right: 6px;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    display: flex;\n    margin: auto;\n    top: 15px;\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n.email__title {\n    width: 380px;\n}\n\n.trash__error__modal,\n.unstake__error__modal {\n    width: 300px;\n    min-height: 200px;\n    height: fit-content;\n    position: fixed;\n    z-index: 99999999;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #F0F0F3;\n    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n}\n\n\n.unstake__error__modal {\n    width: 303px;\n    left: -19px;\n}\n\n.trash__error__modal__title,\n.unstake__error__modal__title {\n    font-size: 16px;\n    line-height: 21px;\n    width: 300px;\n    word-break: break-all;\n    padding: 0 10px;\n    color: #364048;\n    font-weight: 600;\n}\n\n.unstake__error__modal__title {\n    width: unset;\n}\n\n.alert__midal {\n    left: 0;\n}\n\n.trash__title__item {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 90px;\n    height: 1.2em;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    text-align: center;\n    margin: auto 0px;\n}\n\n\n\n.trash__zoom {\n    top: 70px !important;\n    /* left: 0 !important; */\n    right: 60px !important;\n    position: absolute !important;\n    /* bottom: 0 !important; */\n}\n\n.close__card__content {\n    position: absolute;\n    right: 15px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    height: 30px;\n    width: 30px;\n    z-index: 999;\n}\n\n.form__content__error {\n    margin-bottom: 0 !important;\n}\n\n\n.password__message {\n    width: 85%;\n}\n\n.accept_password__message {\n    width: 75%;\n    margin: 15px 0 !important;\n}\n\n.change_password__message {\n    width: 79%;\n}\n\n.version__title {\n    margin: 10px 20px;\n}\n\n.defi__card__unstake {\n    word-break: unset !important;\n}\n\n.active__page__main__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 10px;\n}\n\n.active__page__main {\n    background: #F0F0F3;\n    box-shadow: -10px -10px 30px #ffffff, 10px 10px 30px rgb(174 174 192 / 40%);\n    border-radius: 30px;\n    width: 60%;\n    padding: 20px 10px;\n    position: relative;\n}\n\n.active_loading__layer {\n    position: unset !important;\n    width: unset !important;\n    height: unset !important;\n}\n\n.alerts__input__wrapper div {\n    display: flex !important;\n    align-items: center !important;\n}\n\n.error_message {\n    color: rgb(190, 97, 97) !important;\n    align-items: center;\n    text-align: center;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    font-weight: 500;\n}\n\n.light_defi_row {\n    justify-content: center !important;\n    align-items: center !important;\n\n}\n\n\n.card__nft__wrapper_content {\n    justify-content: start !important;\n    width: 100%;\n    max-height: 200px;\n    overflow: auto;\n    min-height: auto;\n\n\n}\n\n.light_ntf_item_content {\n    width: 100%;\n    padding: 10px;\n    /* height: 290px; */\n}\n\n.light_ntf_item {\n    padding: 5px;\n    cursor: pointer;\n    color: #717679;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 3px;\n}\n\n.light_ntf_item:hover {\n    color: #1762A2 !important;\n}\n\n.card__nft__wrapper_content::-webkit-scrollbar {\n    background-color: none !important;\n    width: 0 !important;\n}\n\n.light_ntf_item_img {\n    height: 20px;\n    width: 20px;\n    border-radius: 50px;\n}\n\n.light_ntf_item_span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100px;\n    height: 1.2em;\n    white-space: nowrap;\n}\n\n.wallet__close__card {\n    z-index: 9 !important;\n    height: 15px;\n}\n\n.wallet__form__header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n\n}\n\n.card__wallet__rates_input {\n    border: none;\n    background: none;\n    outline: none;\n    color: #889096;\n    line-height: 26px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n\n.trash__card__title {\n    margin: 0 !important;\n}\n\n.trash__card__row {\n    margin-bottom: 8px !important;\n}\n\n.card__product__stake__block__light_defi {\n    opacity: 0 !important;\n}\n\n.alert__input__modal {\n    width: 300px;\n    min-height: 200px;\n    height: fit-content;\n    position: absolute;\n    z-index: 99999999;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #F0F0F3;\n    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n    flex-direction: column;\n}\n\n.alert_btn_content {\n    display: flex;\n    width: 70%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n.filter__icon {\n    margin-right: -8px;\n    cursor: pointer;\n}\n\n.chart__container {\n    position: fixed;\n    z-index: 999999;\n    width: fit-content;\n    height: fit-content;\n    display: flex;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n}\n\n.wallet__add {\n    /* margin: auto !important; */\n    width: 32px !important;\n    height: 32px !important;\n    position: absolute !important;\n    top: 10px !important;\n    left: 10px !important;\n}\n\n.adderss_input {\n    width: 100% !important;\n    font-size: 17px !important;\n\n}\n\n.wallet__address__container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.address_input__wrapper {\n    width: 100% !important;\n    margin-bottom: 6px !important;\n    padding: 0 23px 0 50px;\n    font-size: 17px !important;\n\n}\n\n.wallet_address_content {\n    position: relative;\n    width: 96%;\n    margin-left: 60px;\n}\n\n.addresses_items {\n    display: flex;\n    flex-direction: column;\n    width: 100% !important;\n}\n\n.recucle__zoom_btn {\n    margin-right: -45px !important;\n}\n\n\n.empty__trash_container .main:after {\n    content: none !important;\n    height: none !important;\n}\n\n.empty__trash_container .main .content {\n    width: 100% !important;\n}\n\n.asset__list_filter {\n    font-weight: 700 !important;\n}\n\n.assets_nav {\n    display: flex;\n    justify-content: space-between;\n}\n\n.WhitelistForm__container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.alerts__input__wrapper__container {\n    align-items: center;\n    text-align: center;\n    width: 370px;\n    margin-bottom: 20px;\n}\n\n.light_ntf_item_information {\n    display: flex;\n    align-items: center;\n}\n\n.light_ntf_item_span {\n    margin-left: 10px;\n}\n\n.chart__card__title {\n    margin: 0 0 17px 0 !important;\n    font-size: 17px !important;\n}\n\n.trash .card__product__title {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 90px;\n    white-space: nowrap;\n}\n\n.ntf__filter__content {\n    width: 100%;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    border-radius: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 35px;\n    margin-bottom: 5px;\n}\n\n.ntf__filter__input {\n    border: none;\n    background: none;\n    outline: none;\n    font-size: 12px;\n    line-height: 23px;\n    font-weight: 500;\n    color: #889096 !important;\n    width: 100%;\n    padding: 0 5px;\n}\n\n.light_ntf_item_isExist {\n    background: #88909644 !important;\n    border-radius: 24px !important;\n}\n\n\n.contract__address_main_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n}\n\n.contract__address_btn {\n    width: 100px !important;\n    font-size: 14px !important;\n    height: 35px !important;\n}\n\n.contract__address_content {\n    /* width: 320px; */\n    height: 35px;\n    width: 500px;\n}\n\n.chart__catent__value {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin: auto;\n}\n\n.all_conections_ntf {\n    width: 130px;\n}\n\n\n.page__loading__layer {\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    z-index: 999 !important;\n}\n\n\n.unstake__error_message {\n    color: rgb(190, 97, 97);\n    align-items: center;\n    text-align: center;\n    display: flex;\n    font-size: 13px;\n    justify-content: center;\n    font-weight: 600;\n    line-height: 15px;\n    padding: 0 1pc;\n}\n\n.email__input__add {\n    width: 280px !important;\n    margin: 0 auto;\n}\n\n.line__chart {\n    padding: 0 10px;\n}\n\n.limit__block__wrapper_container {\n    position: relative;\n}\n\n.walletShildAccept {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    padding: 16px;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    border-radius: 16px;\n    background-color: #f0f0f3;\n    width: 540px;\n    margin-top: 5px;\n}\n\n.wallet_accept__type__save {\n    width: 100%;\n    height: 32px;\n    border-radius: 67px;\n    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgb(174 174 192 / 40%);\n    background-color: #214175;\n    font-size: 15px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    cursor: pointer;\n    border: 0;\n}\n\n.wallet_input_form {\n    display: flex;\n    flex-direction: column;\n}\n\n.wallet_input_form_title {\n    text-decoration: none;\n    color: #9CA3A8;\n    font-weight: 600;\n    font-size: 14px;\n    border: none;\n    outline: none;\n    line-height: 23px;\n    margin-bottom: 5px;\n}\n\n.wallet_input_form_input {\n    border: none;\n    outline: none;\n    transition: all 0.4s;\n    height: 40px;\n    background: #F0F0F3;\n    border-radius: 67px;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    display: flex;\n    align-items: center;\n    width: 100px;\n    text-align: center;\n    color: #9CA3A8;\n    font-weight: 400;\n    font-size: 13px;\n}\n\n.wallet_input_form_container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    width: 400px;\n    margin: 0 auto 15px;\n}\n\n.assets__wallet__type {\n    position: absolute !important;\n    z-index: 99;\n}\n\n.wallet__shild__card__header {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n\n.rangeslider-vertical .rangeslider__handle {\n    outline: none !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle {\n    outline: none !important;\n}\n\n.whitelist__close__card {\n    top: 0 !important;\n    right: 6px !important;\n}\n\n\n\n.open__trush {\n    left: 28px !important;\n    width: 210px !important;\n}\n\n.wallet__addresses__top__right {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.wallet__first__type {\n    top: 0;\n}\n\n.wallet__modal {\n    padding: 0 24px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.wallet__remove {\n    font-size: 47px;\n    display: flex;\n    margin-top: -12px;\n    color: #2167A4;\n}\n\n.partner_img_item {\n    object-fit: contain !important;\n}\n\n\n.partner__guard__title {\n    font-size: 13px;\n}\n\n\n.asset__select__content {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n}\n\n.asset__select__content_span {\n    color: rgba(0, 0, 0, 0.85);\n    font-weight: 500;\n    text-align: left;\n    font-size: 14px;\n    margin: 5px 0;\n}\n\n.partner__cuard__title {\n    color: #1890ff;\n    margin-left: 10px;\n}\n\n.light__ntf__calc .ant-col-offset-12 {\n    margin: 0 !important;\n}\n\n.ant-table-cell {\n    padding: 10px 0px 10px 5px !important;\n}\n\n.chart__open__btn {\n    position: absolute;\n    left: 10px;\n    cursor: pointer;\n    top: 8px;\n}\n\n.chart__open__btn img {\n    width: 30px;\n    height: 30px;\n}\n\n.edit_asser__modal {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.calc__form {\n    width: 50%;\n}\n\n.calc_modal_description {\n    width: 50%;\n    align-items: center;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0 10px;\n}\n\n.calc_modal_description_title {\n    font-weight: 600;\n    font-size: 20px;\n    font-family: 'Assistant', sans-serif;\n}\n\n.calc_modal_title {\n    font-size: 14px;\n    font-family: 'Assistant', sans-serif;\n    line-height: 28px;\n}\n\n.diferent__title {\n    color: #9575a9;\n    font-weight: bold !important;\n}\n\n.platform__calc__modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.platform__calc__content {\n    margin-top: 140px;\n}\n\n.title__one {\n    color: #9575a9;\n    font-weight: bold !important;\n}\n\n\n.calc__modal {\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    width: 100%;\n}\n\n.asset__calculate_form_modal {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    /* border: 1px solid black; */\n    width: 100%;\n    font-size: 17px;\n    font-weight: 600;\n}\n\n.asset__component__item {\n    width: 46%;\n}\n\n.modal__item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    /* border: 1px solid black; */\n}\n\n\n.asset__calculate_form_modal .ant-form-item {\n    margin-bottom: 0px !important;\n}\n\n.stableCoin__content .ant-form-item-control-input-content {\n    flex: none !important;\n}\n\n.edit__blochain__form {\n    width: 40% !important;\n}\n\n.asset__delete__item__content {\n    width: 100%;\n}\n\n.asset__delete__item__content ant-table-wrapper {\n    width: 100% !important;\n}\n\n\n.dellete__asset__table {\n    font-family: arial, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.dellete__asset__table_td,\n.dellete__asset__table_th {\n    border: 1px solid #dddddd;\n    text-align: left;\n    padding: 8px;\n}\n\n.dellete__asset__table_tr:nth-child(even) {\n    background-color: #dddddd;\n}\n\n.trash_asset__delete__item__content {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.45);\n}\n\n.trash_asset__delete__delete__btns {\n    display: flex;\n    align-items: center;\n    text-align: center;\n}\n\n.restore__btn {\n    margin-right: 10px;\n}\n\n.ant-list-empty-text {\n    display: none;\n}\n\n.defi__shild__trash__title {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 0.85);\n}\n\n.restore_title {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 100);\n    margin: 0 10px;\n}\n\n.defi__shild__trash__symbol__title {\n    margin-left: 5px !important;\n}\n\n\n.no_stable_coin_form .ant-form-item {\n    margin: 0 !important;\n}\n\n.no_stable_coin_form b {\n    color: #1890ff;\n}\n\n\n.calc__form__modal {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin-top: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.calc__form {\n    width: 100%;\n    align-items: center;\n    text-align: center;\n}\n\n.ant-tabs-nav-list {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.ant-tabs-tab {\n    width: 100%;\n    justify-content: center;\n}\n\n.custom-scroll .ant-table-body {\n    /* Custom scrollbar track */\n    scrollbar-color: #d4d4d4 #f4f4f4;\n    scrollbar-width: thin;\n}\n\n.custom-scroll {\n    width: 80vw;\n}\n\n/* Custom scrollbar styles for WebKit browsers */\n.custom-scroll .ant-table-body::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\n.custom-scroll .ant-table-body::-webkit-scrollbar-track {\n    background: #f4f4f4;\n}\n\n.custom-scroll .ant-table-body::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 4px;\n    border: 2px solid #f4f4f4;\n}\n\n.custom-scroll .ant-table-body::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n}\n\n.editable-field {\n    width: 98%;\n}\n\n.custom-checkbox {\n    vertical-align: middle;\n    margin-right: 20px;\n}\n\n.custom-checkbox .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #8c8c8c;\n    border-radius: 4px;\n    transition: all 0.3s ease;\n}\n\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: rgb(61, 162, 194);\n    border-color: rgb(61, 162, 194);\n\n}\n\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: #fff;\n}\n\n.custom-checkbox .ant-checkbox:hover .ant-checkbox-inner {\n    border-color: rgb(61, 162, 194);\n\n}\n\n.custom-checkbox .ant-checkbox-checked:hover .ant-checkbox-inner {\n    background-color: rgb(61, 162, 194);\n}\n\n.ant-space-align-center {\n    align-items: self-end;\n}\n\n.list-header {\n    display: flex;\n    justify-content: space-between;\n    font-weight: bold;\n    padding: 10px 16px;\n    border-bottom: 1px solid #ddd;\n}\n\n.list-header-title {\n    flex: 8;\n}\n\n.list-header-checkbox {\n    flex: 1;\n    text-align: right;\n}\n\n.list-header-actions {\n    flex: 2;\n    text-align: right;\n}\n\n.has_automatic {\n    color: red;\n    margin-left: 10px;\n    width: 18px;\n    height: 18px;\n    display: inline-block;\n    border: 1px solid red;\n    border-radius: 16px;\n    text-align: center;\n    line-height: 18px;\n}\n\n.ant-popover-inner-content {\n    padding: 12px 16px 35px 15px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
